module.exports = __webpack_public_path__ + "img/Phone1and23.3178a8d1.png";